import "./Testimonials.scss";
import { images } from "../../../utils/images";
import { motion } from "framer-motion";
import { Fragment, useEffect, useState } from "react";
import { baseUrl } from "../../../utils/apiData";

const Testimonials = ({ dataList }) => {
  const [num, setNum] = useState(0);

  useEffect(() => {
    const intervalId = setInterval(() => {
      setNum((prev) => prev + 1);
    }, 6000);
    return () => clearInterval(intervalId);
  }, []);
  return (
    <section className="testimonial_sec p_t p_b">
      <motion.img
        initial={{ top: "0px" }}
        whileInView={{ top: "100px" }}
        transition={{
          duration: 0.6,
          ease: "easeInOut",
          delay: 0.15,
        }}
        src={images.triPattern}
        alt="Pattern"
        className="pattern left"
      />
      <motion.img
        initial={{ bottom: "0px" }}
        whileInView={{ bottom: "100px" }}
        transition={{
          duration: 0.6,
          ease: "easeInOut",
          delay: 0.15,
        }}
        src={images.triPattern}
        alt="Pattern"
        className="pattern right"
      />
      <div className="profile">
        {dataList?.map((data, k) => {
          return (
            <Fragment key={data?._id}>
              {num % dataList?.length === k && (
                <motion.img
                  initial={{ scale: 0.5, opacity: 0 }}
                  whileInView={{ scale: 1, opacity: 1 }}
                  transition={{ duration: 0.6, ease: "easeInOut" }}
                  viewport={{ once: true }}
                  src={`${baseUrl}/${data?.image}`}
                  alt="Profile"
                />
              )}
            </Fragment>
          );
        })}
      </div>
      <div className="content_wrap">
        {dataList?.map((data, k) => {
          return (
            <Fragment key={data?._id}>
              {num % dataList?.length === k && (
                <div className="feed_card p_t">
                  <motion.h5
                    initial={{ translateY: 32, opacity: 0 }}
                    whileInView={{ translateY: 0, opacity: 1 }}
                    transition={{ duration: 0.6, ease: "easeInOut" }}
                    viewport={{ once: true }}
                    className="feed text-center"
                  >
                    {data?.description}
                  </motion.h5>
                  <div className="name_info">
                    <motion.p
                      initial={{ translateY: 32, opacity: 0 }}
                      whileInView={{ translateY: 0, opacity: 1 }}
                      transition={{
                        duration: 0.6,
                        ease: "easeInOut",
                        delay: 0.15,
                      }}
                      viewport={{ once: true }}
                      className="name"
                    >
                      {data?.name}
                    </motion.p>
                    <motion.p
                      initial={{ translateY: 32, opacity: 0 }}
                      whileInView={{ translateY: 0, opacity: 1 }}
                      transition={{
                        duration: 0.6,
                        ease: "easeInOut",
                        delay: 0.3,
                      }}
                      viewport={{ once: true }}
                    >
                      {data?.location} {data?.location && data?.position && ","}{" "}
                      {data?.position}
                    </motion.p>
                  </div>
                </div>
              )}
            </Fragment>
          );
        })}

        <div className="btn_wrap">
          {dataList?.map((data, k) => {
            return (
              <button
                className={num % dataList?.length === k ? "active" : ""}
                key={data?._id}
                onClick={() => setNum(k)}
              ></button>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
